import { render, staticRenderFns } from "./Tile.vue?vue&type=template&id=70a4172f&functional=true"
import script from "./Tile.vue?vue&type=script&lang=js"
export * from "./Tile.vue?vue&type=script&lang=js"
import style0 from "./Tile.vue?vue&type=style&index=0&id=70a4172f&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  true,
  null,
  null,
  null
  
)

export default component.exports